import { Component, OnInit, Input, inject } from '@angular/core';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup , ReactiveFormsModule} from '@angular/forms';
import { TextMessagesConfigService } from '../../../services/bidder-community/text-messages/text-messages-config.service';
import { ITextMessagesConfigDTO } from '../../../models/ITextMessagesConfigDTO';
import { CustomValidators } from '../../../shared/validators/custom-validators';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription , distinctUntilChanged} from 'rxjs';
import { AuthService } from '../../../services/authentication/auth.service';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { RouterModule } from '@angular/router';
import { InputRestrictDirective } from '../../../directives/input-restrict/input-restrict.directive';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-text-messages',
  imports: [
    CheckboxModule, 
    InputTextModule, 
    FontAwesomeModule, 
    SelectModule,
    ButtonModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    InputRestrictDirective
  ],
  templateUrl: './text-messages.component.html',
  styleUrl: './text-messages.component.scss'
})
export class TextMessagesComponent implements OnInit {

  private readonly textMessagesConfigService = inject(TextMessagesConfigService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly authService = inject(AuthService);
  private readonly messageService = inject(ToastMessageService);

  isAuthenticated = this.oidcSecurityService.authenticated;
  textMessagesConfig: ITextMessagesConfigDTO | null = null;
  form: FormGroup;
  authSubscription!: Subscription;
  
  startTimeErrorMessage:string = 'Start Time must be earlier than End Time';

  timezones: string[] = [
    "America/Puerto_Rico",
    "America/Virgin",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Hobart",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney",
    "Canada/Atlantic",
    "Canada/Central",
    "Canada/Eastern",
    "Canada/Mountain",
    "Canada/Newfoundland",
    "Canada/Pacific",
    "Canada/Saskatchewan",
    "Canada/Yukon",
    "Indian/Christmas",
    "Indian/Cocos",
    "Pacific/Auckland",
    "Pacific/Guam",
    "Pacific/Norfolk",
    "Pacific/Palau",
    "US/Alaska",
    "US/Arizona",
    "US/Central",
    "US/Eastern",
    "US/Hawaii",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific"
  ];

  startTimes: string[] = [
    "12:00 AM",
    "1:00 AM",
    "2:00 AM",
    "3:00 AM",
    "4:00 AM",
    "5:00 AM",
    "6:00 AM",
    "7:00 AM",
    "8:00 AM",
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
    "6:00 PM",
    "7:00 PM",
    "8:00 PM",
    "9:00 PM",
    "10:00 PM",
    "11:00 PM",
  ];

  endTimes: string[] = [...this.startTimes, "11:59 PM"];

  constructor( private bidderCommunityMenuService: BidderCommunityMenuService, private fb: FormBuilder){
    this.form = this.fb.group({
          outbidAlert: [false],
          auctionUpdates: [false],
          mobilePhone: ['', [CustomValidators.internationalPhoneNumberValidator('Mobile Phone')]],
          startTime: ['', [CustomValidators.required('Start Time')]],
          endTime: ['', [CustomValidators.required('End Time')]],
          timezone: ['', [CustomValidators.required('Time Zone')]]
        });
  }
  public faInfoCircle = faInfoCircle; 
  @Input() id: number | null = null;
  ngOnInit(){
    this.bidderCommunityMenuService.setPageData(
      {
        id: this.id!,
        pageName:"Text Messages",
        pageRoute:"text-messages"
      }
    );

    if (typeof window !== 'undefined') {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
      if (!this.isAuthenticated().isAuthenticated) {
        window.open(environment.mediaUrl, '_self');
        return;
      }else{
        this.getTextMessagesConfig();
      }
    }

    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (isAuth) {
        this.getTextMessagesConfig();
      } else {
        if (typeof window !== 'undefined') {
          window.open(environment.mediaUrl, '_self');
        }
        return;
      }
    });
  }

  isStartTimeValid(){
    return this.startTimes.indexOf(this.form.controls['startTime'].value) <  
      this.startTimes.indexOf(this.form.controls['endTime'].value) || 
      this.startTimes.indexOf(this.form.controls['endTime'].value) == -1
  }

  getFieldError(field: string): string | null {
    const control = this.form.get(field);
    if (control && control.errors && (control.dirty || control.touched)) {
      const firstErrorKey = Object.keys(control.errors)[0];
      return control.errors[firstErrorKey];
    }
    return null;
  }

  getTextMessagesConfig() {
    this.textMessagesConfigService.getTextMessageConfig().subscribe(({
      next: () => {
        this.textMessagesConfig = this.textMessagesConfigService.textMessagesConfigSignal();
        if (this.textMessagesConfig) {
          this.form.patchValue({
            outbidAlert: this.textMessagesConfig.outbidAlert,
            auctionUpdates : this.textMessagesConfig.auctionUpdates,
            mobilePhone: this.textMessagesConfig.mobilePhone,
            startTime : this.textMessagesConfig.startTime,
            endTime: this.textMessagesConfig.endTime,
            timezone: this.textMessagesConfig.timezone,
          });
        }
      },
      error: (err) => {
        console.log('Error retrieve data', err);
      }
    }))
  }

  onSubmit(){

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if(!this.isStartTimeValid())  {
        this.form.markAllAsTouched();
        this.messageService.error(this.startTimeErrorMessage);
      return;
    }

    const formData: ITextMessagesConfigDTO = this.form.getRawValue();   

    this.textMessagesConfigService.putTextMessagesConfigInfo(formData).subscribe({
      next: () => {
        this.messageService.success(`Your Text Messages configuration has been saved.`);
      },
      error: (err) => {
        let errorMsg = 'unknown error';

        if (typeof err.error === 'string') {
          try {
            const parsed = JSON.parse(err.error);
            errorMsg = parsed.message || errorMsg;

          } catch {
            errorMsg = err.error;
          }
        }
        else if (err.error && err.error.errorMessage) {
          errorMsg = err.error.errorMessage;
        }

        this.messageService.error(errorMsg || 'unknown error');
      }
    })

  }
}
